import { FieldTestsStorageManager } from "../storageBase";
import { Tracking } from "../tracking/Tracking";
import { weightedRandom } from "./weightedRandom";
export class FieldTests {
    constructor() {
        this.sentToAnalytics = new Set();
        this.deviceType = "";
    }
    applyExperiments(experiments) {
        experiments.forEach((experiment) => {
            const experimentAPI = {
                assignVariant: () => this.assignVariant(experiment),
                clearVariant: () => this.clearVariant(experiment),
                getVariant: () => this.getVariant(experiment),
                isParticipatingInOtherTests: () => this.isParticipatingInOtherTests(experiment.name),
            };
            experiment.apply(experimentAPI);
        });
    }
    cleanUpAfterOtherTestsThan(currentExperiments) {
        const variants = this.getAllVariants();
        const currentExperimentNames = currentExperiments.map((experiment) => experiment.name);
        Object.keys(variants).forEach((experimentName) => {
            if (!currentExperimentNames.includes(experimentName)) {
                delete variants[experimentName];
                this.sentToAnalytics.delete(experimentName);
            }
        });
        this.setAllVariants(variants);
    }
    getVariant(experiment) {
        const variants = this.getAllVariants();
        return experiment.name in variants
            ? variants[experiment.name]
            : experiment.controlVariant;
    }
    assignVariant(experiment) {
        const variants = this.getAllVariants();
        if (!(experiment.name in variants)) {
            variants[experiment.name] = weightedRandom(experiment.variants);
            console.log(`[FieldTest] Experiment ${experiment.name}: selecting and saving variant ${variants[experiment.name]}`);
            this.setAllVariants(variants);
        }
        else {
            console.log(`[FieldTest] Experiment ${experiment.name}: already chose variant ${variants[experiment.name]}`);
        }
        const value = variants[experiment.name];
        if (!this.sentToAnalytics.has(experiment.name)) {
            Tracking.trackEvent({
                tag: "ExperienceImpression",
                contents: {
                    experiment: experiment.name,
                    variant: value,
                    device_type: this.deviceType,
                },
            });
            this.sentToAnalytics.add(experiment.name);
        }
        return value;
    }
    clearVariant(experiment) {
        const variants = this.getAllVariants();
        delete variants[experiment.name];
        this.setAllVariants(variants);
    }
    getAllVariants() {
        var _a;
        return (_a = FieldTestsStorageManager.restore()) !== null && _a !== void 0 ? _a : {};
    }
    setAllVariants(variants) {
        FieldTestsStorageManager.store(variants);
    }
    isParticipatingInOtherTests(currentExperimentName) {
        const variants = this.getAllVariants();
        const test = Object.keys(variants).some((testName) => testName !== currentExperimentName && !!variants[testName]);
        return test;
    }
    /** This is needed to send device type with tracking event, due to SQL performance reasons */
    setDeviceType(deviceType) {
        this.deviceType = deviceType;
    }
}
